import AppDispatcher from '../AppDispatcher';

const QuoteHistoryActions = {
  set: (items) => {
    AppDispatcher.dispatch({
      actionType: Constants.ActionTypes.QUOTE_HISTORY.SET,
      items: items
    });
  },
  update: () => {
    AppDispatcher.dispatch({
      actionType: Constants.ActionTypes.QUOTE_HISTORY.UPDATE
    });
  }
};

export default QuoteHistoryActions;



// WEBPACK FOOTER //
// ./src/js/Actions/QuoteHistoryActions.js